class Helper{

  static checkUserGroupPermissions(userGroups, selectedLocation,  usersFreeChargingLocations){
    try {
      let isFreeCharging = false;
      let customEnergyRate = 0;
      let isCustomEnergyRateForSelectedLocation = false;
          userGroups.filter((userGroup) => {
            try {
    
              let parsedPermissions = JSON.parse(userGroup.permissions)
    
              try {
                if (parsedPermissions?.freeCharging && parsedPermissions?.freeCharging === 'allowed') {
                  
    
                  if ("freeChargingAllowedLocations" in parsedPermissions) {
                    isFreeCharging = Helper.isFreeChargingAllowedInSelectedLocation(parsedPermissions.freeChargingAllowedLocations, usersFreeChargingLocations, selectedLocation) //isFreeChargingAllowedInSelectedLocation(parsedPermissions.freeChargingAllowedLocations)
                  } else {
                    isFreeCharging = Helper.isFreeChargingAllowedInSelectedLocation()
                  }
                  // isFreeCharging ? setIsFreeChargingForSelectedLocation(true) : setIsFreeChargingForSelectedLocation(false)
    
                }
              } catch (error) {
                console.log(error.message)
              }
    
              try {
                if (parsedPermissions?.customEnergyRate && parsedPermissions?.customEnergyRate === 'enabled') {
                  let isCustomEnergyRateEnabled = false
                  if ("customEnergyRateEnabledLocations" in parsedPermissions) {
                    isCustomEnergyRateEnabled = Helper.isCustomEnergyRateEnabledInSelectedLocation(parsedPermissions.customEnergyRateEnabledLocations, selectedLocation)
                  } else {
                    isCustomEnergyRateEnabled = true
                  }
    
    
                  if (isCustomEnergyRateEnabled) {
                    isCustomEnergyRateForSelectedLocation = true
                    customEnergyRate = parsedPermissions?.customEnergyRateEnabledRate
                    // setCustomEnergyRate(parsedPermissions?.customEnergyRateEnabledRate)
                  } else {
                    isCustomEnergyRateForSelectedLocation = false
                    customEnergyRate = 0
                    // setIsCustomEnergyRateForSelectedLocation(false)
                    // setCustomEnergyRate(0)
                  }
                }
    
              } catch (error) {
                console.log(error.message)
              }
    
    
            } catch (error) {
              console.log(error.message)
            }
    
          })


      //   let isFreeCharging = false;
      // let customEnergyRate = 0;
      // let isCustomEnergyRateForSelectedLocation = false;
      return {
        isFreeCharging: isFreeCharging,
        customEnergyRate: customEnergyRate,
        isCustomEnergyRateForSelectedLocation: isCustomEnergyRateForSelectedLocation
      }
        } catch (error) {
          console.log(error.message)
          return {
            isFreeCharging: false,
            customEnergyRate: 0,
            isCustomEnergyRateForSelectedLocation: false
          }
        }
    
  }

   static isCustomEnergyRateEnabledInSelectedLocation(customEnergyRateEnabledLocations = null, selectedLocation) {
    try {
      if (customEnergyRateEnabledLocations) {
        if (customEnergyRateEnabledLocations.length === 0) {
          return true
        } else {
          if (customEnergyRateEnabledLocations.includes(selectedLocation)) {
            return true
          } else {
            return false
          }
        }
      }
    } catch (error) {
      console.log(error.message)
    }

  }
  static isFreeChargingAllowedInSelectedLocation(locationsFromPermission = [], usersFreeChargingLocations = [], selectedLocation="") {

    if (usersFreeChargingLocations.includes(selectedLocation)) {

      return true
    }
    if (locationsFromPermission.includes(selectedLocation)) {
      return true
    }
    // }
    if (usersFreeChargingLocations.length === 0 && locationsFromPermission.length === 0) {
      return true
    }
    return false;
  }

  static checkCustomerPermissions(userGroups) {
    let permissions = []
    try {
      if(userGroups.length > 0){
       userGroups.filter((userGroup) => {
        let parsedPermissions = JSON.parse(userGroup.permissions)
        if(parsedPermissions?.customerUserControl && parsedPermissions?.customerUserControl === 'enabled'){
          permissions.push('userControl');
        }
        if(parsedPermissions?.customerChargerControl && parsedPermissions?.customerChargerControl === 'enabled'){
          permissions.push('chargerControl');
        }
        if(parsedPermissions?.rateControllCustomer && parsedPermissions?.rateControllCustomer === 'yes'){
          permissions.push('rateControll');
        }
        if(parsedPermissions?.bookingViewCustomer && parsedPermissions?.bookingViewCustomer === 'yes'){
          permissions.push('bookingView');
        }
       })
      }

      return permissions;
    }catch (error) {
      console.log(error.message)
    }
  }




    static calculateEstimatedAmount(time, startDateTime, endDateTime, selectedCharger, isBookingNonRes, isCustomEnergyRateForSelectedLocation, customEnergyRate, selectedChargerForNonRes, chargers, locationData, durationReFill, startInstantly, userAvgPower = 0, isNightCharging = false, gracePeriodInMinutes = 10) {
      
      // console.log("Helper estimate amount",time, startDateTime, endDateTime, selectedCharger, isBookingNonRes, isCustomEnergyRateForSelectedLocation, customEnergyRate, chargers, locationData, durationReFill)
      // console.log("endDateTime in estimate: ", endDateTime)
      let rateSplit = { 'tax': 0, 'normalRate': 0, 'dynamicRates': [] }
      let endDateTimeObj = new Date(endDateTime);
      let isEndDateTimeValid = endDateTime && !isNaN(endDateTimeObj.getTime());
        let endDateTimeCompensated =  isBookingNonRes
  ? new Date(new Date(startDateTime).getTime() + (time * 60 * 1000))
  : (isEndDateTimeValid
      ? endDateTimeObj
      : new Date(new Date(startDateTime).getTime() + (time * 60 * 1000)));
    // console.log("endDateTimeCompensated before: ", endDateTimeCompensated)
    // console.log("duration refill: ", durationReFill)
    // console.log("startInstantly: ", startInstantly)
    // console.log("isEndDateTimeValid: ", isEndDateTimeValid)
    let startDateTimeCompensated =  isEndDateTimeValid ? new Date(startDateTime) : ( startInstantly ? new Date() : new Date(startDateTime));
    // console.log("startDateTimeCompensated : ", startDateTimeCompensated)
    endDateTimeCompensated = new Date(endDateTimeCompensated.setMinutes(endDateTimeCompensated.getMinutes() - (isNightCharging ? 0 : ((time+durationReFill) >= 30 ? gracePeriodInMinutes : 5)))) //((new Date(endTimeWithGrace) - new Date(startTime)) >= 30 * 60000) ? 10 : 5
    // console.log("endDateTime compensated : ", endDateTimeCompensated)               
    let estimateAmount = 0

    let costPerMin = 0

    // console.log("chargers in estimate: ", selectedChargerForNonRes)
    // console.log("chargers in selected location: ", chargers)
    // console.log("selected charger id in booking : ", selectedCharger) 
    let selectedChargerData = isBookingNonRes ? selectedChargerForNonRes : (selectedCharger
  ? chargers.find((charger) =>
      Array.isArray(charger.connector) &&
      charger.connector.find((conn) => conn._id === selectedCharger)
    )
  : chargers[0])
  // console.log("selected charger data in estimate; ",selectedChargerData)
  let selectedConenctorData = (selectedChargerData  && !isBookingNonRes ) ? selectedChargerData.connector.find((conn) => conn._id === selectedCharger) : null
  // console.log("selected connector data: ", selectedConenctorData)
    // console.log("selected charger data for calculate estimate amount: ", selectedChargerData)
      // console.log("selectedChargerData",selectedChargerData)
      // console.log("non res",isBookingNonRes)
    let chargerEnergyRating = 0
    // console.log("selected charger data in estiamte: ", selectedChargerData)
    // console.log("chargers in estimate: ", chargers)
    // console.log("selected charger: ", selectedCharger)
    if(isBookingNonRes){
      chargerEnergyRating = selectedChargerData.power
    }else{
      chargerEnergyRating = selectedCharger ? selectedConenctorData.power : parseFloat(chargers[0].connector[0].power)
      
    } 
    let chargerRatedPower = chargerEnergyRating
    let isUserAvgPowerUsed = false
    // console.log("User avg power:", userAvgPower)
    if(selectedChargerData.chargerLevel === 'L2'){
      if(userAvgPower && userAvgPower.l2 >0 && userAvgPower.l2 < chargerEnergyRating){
        chargerEnergyRating = userAvgPower.l2;
        isUserAvgPowerUsed = true;
      }
    }
    if(selectedChargerData.chargerLevel === 'L3'){
      if(userAvgPower && userAvgPower.l3 >0 && userAvgPower.l3 < chargerEnergyRating){
        chargerEnergyRating = userAvgPower.l3;
        isUserAvgPowerUsed = true;
      }
    }
    rateSplit['powerUsed'] = chargerEnergyRating
    rateSplit['chargerRatedPower'] = chargerRatedPower
    rateSplit['isUserAvgPowerUsed'] = isUserAvgPowerUsed
    // chargerEnergyRating = userAvgPower && userAvgPower > 0 ? userAvgPower : chargerEnergyRating;
      // console.log("chargerEnergyRating",chargerEnergyRating)
    // console.log("charger energy rating: ", chargerEnergyRating)

    let rate = isCustomEnergyRateForSelectedLocation ? parseFloat(customEnergyRate) : ( selectedChargerData ? selectedChargerData.rate.price_components.price : 0)
    let taxPercent = selectedChargerData ? selectedChargerData.rate.price_components.tax : 0
    let dynamicTime = 0
    let normalRateDuration = (endDateTimeCompensated - startDateTimeCompensated) / (1000 * 60);
    // console.log("normal rate duration: ", normalRateDuration)
    if (selectedChargerData.rateType === "fixed" || isCustomEnergyRateForSelectedLocation) {
      costPerMin = (rate * chargerEnergyRating) / 60;
      estimateAmount = costPerMin * normalRateDuration // ((parseFloat(time, 10) + parseFloat(durationReFill, 10)) - ((time+durationReFill) >= 30 ? 10 : 5));
      rateSplit['tax'] = estimateAmount * (taxPercent / 100)
      rateSplit['normalRate'] = estimateAmount
      return { estimateAmount: (estimateAmount + (estimateAmount * (taxPercent / 100))), normalRate: rate, rateType: 'fixed', rateSplit: rateSplit } // add tax
    }
    let timezone = locationData[0].timezone;
    // console.log("startDateTimeCompensated", startDateTimeCompensated)
    // console.log("endDateTimeCompensated: ", endDateTimeCompensated)
    startDateTimeCompensated = Helper.convertToChargerTimeZone(startDateTimeCompensated, timezone)
    endDateTimeCompensated = Helper.convertToChargerTimeZone(endDateTimeCompensated, timezone)
    let applicableDynamicRangesStart = [];
    let applicableDynamicRangesEnd = [];
    let applicableDynamicRangesCorrected = []; //TO adjust for free time slots

    let applicableDynamicRanges = selectedChargerData.dynamicRates.filter(
      (rate) => {
        return (rate.applicableDays[startDateTimeCompensated.getDay()] === 1 || rate.applicableDays[endDateTimeCompensated.getDay()] === 1)
      }
    )
    let newApplicableDynamicRanges = [];
    let applicableDynamicRangeCurrent = JSON.parse(JSON.stringify(applicableDynamicRanges)) //To create a copy of the existing array
    applicableDynamicRanges.length > 1 ?
      applicableDynamicRanges.forEach((range, index) => {
        for (let i = index + 1; i <= applicableDynamicRanges.length - 1; i++) {
          newApplicableDynamicRanges = Helper.dynamicRangeFreeSlotCheck(range, applicableDynamicRanges[i], applicableDynamicRangeCurrent, index, i)
        }

      }) : newApplicableDynamicRanges = JSON.parse(JSON.stringify(applicableDynamicRanges))

    newApplicableDynamicRanges.filter(
      (rate) => {
        if (rate.applicableDays[startDateTimeCompensated.getDay()] === 1) {
          applicableDynamicRangesStart.push(rate)
        }
        if (rate.applicableDays[endDateTimeCompensated.getDay()] === 1) {
          applicableDynamicRangesEnd.push(rate)
        }
        return (rate.applicableDays[startDateTimeCompensated.getDay()] === 1 || rate.applicableDays[endDateTimeCompensated.getDay()] === 1)
      }
    )

    if (startDateTimeCompensated.getDay() === endDateTimeCompensated.getDay()) {
      newApplicableDynamicRanges.forEach(element => {
        let { rangeStart, rangeEnd } = Helper.convertToTimezone(element.timeRange, timezone, startDateTimeCompensated);
        costPerMin = (element.rate * chargerEnergyRating) / 60;


        //condtion 4 - rangeStart <startDateTime < rangeEnd && rangeStart < endDateTime < rangeEnd  // range encompassing the start and end
        if (rangeStart <= startDateTimeCompensated && startDateTimeCompensated <= rangeEnd && rangeStart <= endDateTimeCompensated && endDateTimeCompensated <= rangeEnd) {
          dynamicTime = (new Date(endDateTimeCompensated) - new Date(startDateTimeCompensated)) / (1000 * 60);
        
          estimateAmount = costPerMin * dynamicTime
          rateSplit['dynamicRates'].push( {'rangeStart': rangeStart, 'rangeEnd': rangeEnd, 'estimateInRange': estimateAmount, 'perkWhCost': element.rate} )
          rateSplit['tax'] = estimateAmount * (taxPercent / 100)
          normalRateDuration = 0;
          return { estimateAmount: (estimateAmount + (estimateAmount * (taxPercent / 100))), applicableDynamicRanges: applicableDynamicRanges, rateType: selectedChargerData.rateType, normalRate: rate, rateSplit: rateSplit }
        }
        let { calcEstimateAmount, calcDynamicTime } = Helper.bookingDurationCalculation(startDateTimeCompensated, endDateTimeCompensated, rangeStart, rangeEnd, costPerMin)
       
        estimateAmount += calcEstimateAmount;
        normalRateDuration -= calcDynamicTime
        rateSplit['dynamicRates'].push( {'rangeStart': rangeStart, 'rangeEnd': rangeEnd, 'estimateInRange': calcEstimateAmount, 'perkWhCost': element.rate} )
        
      });
    }
    else {
      let result = null
      // Booking Span
      // Booking duration split into two startTime - startDateEndTime and endDateStartTIme - endTime
      // Booking part current day
      applicableDynamicRangesStart.forEach(element => {
        let { rangeStart, rangeEnd } = Helper.convertToTimezone(element.timeRange, timezone, startDateTimeCompensated);
        costPerMin = (element.rate * chargerEnergyRating) / 60;
        let startTimeDayEnd = new Date(new Date(startDateTimeCompensated).setHours(23, 59, 59, 999))
        result = Helper.bookingDurationCalculation(startDateTimeCompensated, startTimeDayEnd, rangeStart, rangeEnd, costPerMin)
        estimateAmount += result.calcEstimateAmount;
        normalRateDuration -= result.calcDynamicTime
        rateSplit['dynamicRates'].push( {'rangeStart': rangeStart, 'rangeEnd': rangeEnd, 'estimateInRange': result.calcEstimateAmount, 'perkWhCost': element.rate} )
      });

      //Booking part next day
      applicableDynamicRangesEnd.forEach(element => {
        let { rangeStart, rangeEnd } = Helper.convertToTimezone(element.timeRange, timezone, endDateTimeCompensated);
        costPerMin = (element.rate * chargerEnergyRating) / 60;
        let endTimeDayStart = new Date(new Date(endDateTimeCompensated).setHours(0, 0, 0, 0))
        result = Helper.bookingDurationCalculation(endTimeDayStart, endDateTimeCompensated, rangeStart, rangeEnd, costPerMin)
        estimateAmount += result.calcEstimateAmount;
        normalRateDuration -= result.calcDynamicTime
        rateSplit['dynamicRates'].push( {'rangeStart': rangeStart, 'rangeEnd': rangeEnd, 'estimateInRange': result.calcEstimateAmount, 'perkWhCost': element.rate} )
      });
    }
    costPerMin = (rate * chargerEnergyRating) / 60;
    estimateAmount += costPerMin * normalRateDuration;
    rateSplit['normalRate'] = costPerMin * normalRateDuration
    rateSplit['tax'] =(estimateAmount * (taxPercent / 100))
    // console.log("Estimate AMount", estimateAmount)
    return { estimateAmount: (estimateAmount + (estimateAmount * (taxPercent / 100))), applicableDynamicRanges: applicableDynamicRanges, rateType: selectedChargerData.rateType, normalRate: rate, rateSplit: rateSplit }
    }

    static convertToChargerTimeZone(utcDate, timeZone) {
        // Ensure utcDate is a Date object
        const date = new Date(utcDate);
    
        // Use Intl.DateTimeFormat to convert the date to the specified time zone
        const options = {
          timeZone: timeZone,
          hour12: false, // 24-hour format
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        };
    
        const formatter = new Intl.DateTimeFormat('en-US', options);
        const parts = formatter.formatToParts(date);
    
        // Extracting the individual date/time components
        const result = {};
        parts.forEach(({ type, value }) => {
          result[type] = value;
        });
    
        // Ensure the format is compatible with Date constructor (YYYY-MM-DDTHH:mm:ss)
        const formattedDate = `${result.year}-${result.month}-${result.day}T${result.hour}:${result.minute}:${result.second}`;
    
        // Return the new Date object in the specified time zone
        return new Date(formattedDate);
      }


      static dynamicRangeFreeSlotCheck = (range1, range2, applicableDynamicRange, range1Index, range2Index) => {

        let updatedTimeRange = '';
        let rangeFree = null;
        let rangePaid = null;
        let index = null;
        let applicableRangesModified = applicableDynamicRange;
        if (range1.freeCharging === true && range2.freeCharging === true) {
          return applicableRangesModified
        }
        if (range1.freeCharging === true) {
          rangeFree = range1.timeRange
          rangePaid = range2.timeRange
          index = range2Index;
        } else if (range2.freeCharging === true) {
          rangeFree = range2.timeRange
          rangePaid = range1.timeRange
          index = range1Index;
        } else {
          return applicableRangesModified
        }
        let [rfStart, rfEnd] = rangeFree.split("-")
        let [rpStart, rpEnd] = rangePaid.split("-")
        const convertTime = (time) => {
          const [hours, minutes, secondsWithMillis] = time.split(':');
          const [seconds, milliseconds] = secondsWithMillis.split('.');
          let date = new Date();
          date.setHours(hours, minutes, seconds, milliseconds);
          return date;
        };
        rfStart = convertTime(rfStart);
        rfEnd = convertTime(rfEnd);
        rpStart = convertTime(rpStart);
        rpEnd = convertTime(rpEnd);
        if (rfEnd <= rfStart) {
          rfEnd.setDate(rfEnd.getDate() + 1)
        }
        if (rpEnd <= rpStart) {
          rpEnd.setDate(rpEnd.getDate() + 1)
        }
    
        if ((rpStart <= rfStart && rpEnd >= rfStart) && (rpStart <= rfEnd && rpEnd <= rfEnd)) {
          //Span over free time start Action - paid slot end time = free slot start time - 1 ms
          rpEnd = new Date(rfStart.getTime() - 1)
          updatedTimeRange = `${Helper.convertToTimeString(rpStart)}-${Helper.convertToTimeString(rpEnd)}`
          applicableRangesModified[index].timeRange = updatedTimeRange;
    
        } else if ((rpStart >= rfStart && rpEnd >= rfStart) && (rpStart <= rfEnd && rpEnd >= rfEnd)) {
          // Span over free end time - Action  - paid slot start time = free end time + 1
          rpStart = new Date(rfEnd.getTime() + 1)
          updatedTimeRange = `${Helper.convertToTimeString(rpStart)}-${Helper.convertToTimeString(rpEnd)}`
          applicableRangesModified[index].timeRange = updatedTimeRange;
    
        } else if ((rpStart >= rfStart && rpEnd >= rfStart) && (rpStart <= rfEnd && rpEnd <= rfEnd)) {
          //Paid slot within free slot - Action Remove paid slot 
          updatedTimeRange = `${Helper.convertToTimeString(rpStart)}-${Helper.convertToTimeString(rpStart)}`
          applicableRangesModified[index].timeRange = updatedTimeRange;
          applicableRangesModified[index].rate = 0
    
        } else if ((rpStart <= rfStart && rpEnd >= rfStart) && (rpStart <= rfEnd && rpEnd >= rfEnd)) {
          //Free slot within paid slot Action - Split into two slots - 1) rpStart - rfStart-1 - 2) rfEnd+1 - rpEnd
          let tempStart = rpStart;
          let tempEnd = rpEnd;
          let tempSlot = { ...applicableRangesModified[index] }
          // slot 1
          rpEnd = new Date(rfStart.getTime() - 1)
          updatedTimeRange = `${Helper.convertToTimeString(rpStart)}-${Helper.convertToTimeString(rpEnd)}`
          applicableRangesModified[index].timeRange = updatedTimeRange;
          //slot 2
          tempStart = new Date(rfEnd.getTime() + 1);
          updatedTimeRange = `${Helper.convertToTimeString(tempStart)}-${Helper.convertToTimeString(tempEnd)}`
          tempSlot.timeRange = updatedTimeRange;
          applicableRangesModified.push(tempSlot)
    
        } else {
          console.log("   ....   ")
        }
    
        return applicableRangesModified
      }
    
      static convertToTimeString(timestamp) {
        let updatedDate = timestamp
        const utcHours = updatedDate.getHours().toString().padStart(2, '0');
        const utcMinutes = updatedDate.getMinutes().toString().padStart(2, '0');
        const utcSeconds = updatedDate.getSeconds().toString().padStart(2, '0');
        const utcMilliseconds = updatedDate.getMilliseconds().toString().padStart(3, '0');
        return `${utcHours}:${utcMinutes}:${utcSeconds}.${utcMilliseconds}`;
      }

      static convertToTimezone = (timeString, timezone, dateFactor) => {
        const [startTime, endTime] = timeString.split('-');
    
        const convertTime = (time, timeZone) => {
          const [hours, minutes, seconds] = time.split(':');
          let date = new Date(dateFactor);
          let dateFactorDate = date.getDate();
    
          date.setHours(hours, minutes, seconds, 0);
    
          let offset = Helper.getTargetZoneOffset(timezone, date)
          date = new Date(date.getTime() + (offset * 60 * 1000))
          date.setDate(dateFactorDate)
    
          return date;
        };
    
        let startDateInTimezone = convertTime(startTime);
        let endDateInTimezone = convertTime(endTime);
    
        return { rangeStart: startDateInTimezone, rangeEnd: endDateInTimezone };
      };


      static bookingDurationCalculation = (startDateTimeCompensated, endDateTimeCompensated, rangeStart, rangeEnd, costPerMin) => {
        let dynamicTime = 0;
        let estimateAmount = 0;
    
        //condition 1 - rangeStart<startDateTime<rangeEnd && rangeStart < endDateTime > rangeEnd // span over start time
        if (rangeStart <= startDateTimeCompensated && startDateTimeCompensated <= rangeEnd && rangeStart <= endDateTimeCompensated && endDateTimeCompensated >= rangeEnd) {
          dynamicTime = (new Date(rangeEnd) - new Date(startDateTimeCompensated)) / (1000 * 60);
          estimateAmount = (costPerMin * dynamicTime)
        }
        //condtion 2 - rangeStart > startDateTime < rangeEnd && rangeStart < endDateTime < rangeEnd // span over end time
        else if (rangeStart >= startDateTimeCompensated && startDateTimeCompensated <= rangeEnd && rangeStart <= endDateTimeCompensated && endDateTimeCompensated <= rangeEnd) {
          dynamicTime = (new Date(endDateTimeCompensated) - new Date(rangeStart)) / (1000 * 60);
          estimateAmount = (costPerMin * dynamicTime)
        }
        //condition 3 - rangeStart > startDateTime < rangeEnd && rangeStart < endDateTime > rangeEnd // range within start and end
        else if (rangeStart >= startDateTimeCompensated && startDateTimeCompensated <= rangeEnd && rangeStart <= endDateTimeCompensated && endDateTimeCompensated >= rangeEnd) {
          dynamicTime = (new Date(rangeEnd) - new Date(rangeStart)) / (1000 * 60);
          estimateAmount = (costPerMin * dynamicTime)
        }
        else if (rangeStart <= startDateTimeCompensated && endDateTimeCompensated <= rangeEnd) {
          dynamicTime = (new Date(endDateTimeCompensated) - new Date(startDateTimeCompensated)) / (1000 * 60);
          estimateAmount = (costPerMin * dynamicTime);
        }
    
        else {
          console.log(" .... ")
        }
    
        return { calcEstimateAmount: estimateAmount, calcDynamicTime: dynamicTime }
      }

      static getTargetZoneOffset(timeZone, date = new Date()) {
        try {
    
    
          const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone,
            hour12: false,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          });
    
          const parts = formatter.formatToParts(date);
          const hourPart = parts.find(part => part.type === 'hour');
          const minutePart = parts.find(part => part.type === 'minute');
    
          const hour = parseInt(hourPart.value, 10);
          const minute = parseInt(minutePart.value, 10);
    
          // Get UTC time
          const utcHour = date.getUTCHours();
          const utcMinute = date.getUTCMinutes();
    
          const hourOffset = hour - utcHour;
          const minuteOffset = minute - utcMinute;
    
          return (hourOffset * 60) + minuteOffset; // Offset in minutes
        } catch (e) {
          console.error('Failed to calculate timezone offset:', e);
          return 0;
        }
      }
}
export default Helper